







































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
import DataCell from "./DataCell.vue";
import { CellData, IndicatorData, DataQualityHeader, DataQualityRow } from "@/types/dataQuality/dataQualityTable";
import { getModule } from "vuex-module-decorators";
import UserModule from "@/store/clients/User.module";

const User = getModule(UserModule, store);

@Component({
  components: {
    DataCell,
  },
})
export default class DataOutliersTable extends Vue {
  @Prop({ type: Boolean, default: false }) loading!: Boolean;
  @Prop({ type: Array, default: () => [] }) headers!: DataQualityHeader[];
  @Prop({ type: Array, default: () => [] }) rows!: DataQualityRow[];
  @Prop({ type: Array, default: () => [] }) links!: string[] | null;

  sortBy = "";
  isLoadingTextDisplay = false;
  sortDesc = false;
  pageLimit = 10;
  pageCount = 0;
  currentItems: DataQualityRow[] = [];
  currentPage = 1;

  //  @Getters
  get isLessThanLimit(): boolean {
    return this.rows.length <= this.pageLimit;
  }

  get skeletonStructure(): object {
    return { "table-row": "table-cell@7" };
  }

  //  @Methods
  cellData(row: DataQualityRow, header: DataQualityHeader, index: number): any {
    return {
      column: header.value,
      columnName: header.text,
      featureName: header.text, // Original feature name with spaces
      vesselId: row.vesselId,
      type: header.type,
      align: header.align,
      value: row[header.value].value,
      unmanagedCount: row[header.value].unmanagedCount,
      autoRemovedCount: row[header.value].autoRemovedCount,
      physicalBoundsCount: row[header.value].physicalBoundsCount,
      smartOutliersCount: row[header.value].smartOutliersCount,
      detectionTime: row[header.value].detectionTime,
      link: row[header.value].link,
    };
  }

  headerClasses(header: any): string[] {
    return [
      header.class,
      {
        sortable: header.sortable,
        "no-sort": this.sortBy !== header.value,
      },
    ];
  }

  headerStyles(header: any): any {
    return {
      width: header.width ? header.width : "auto",
      "min-width": header.width ? header.width : "auto",
    };
  }

  highlightRedirectedVessel(item: DataQualityRow, rowIndex: string): boolean {
    const vesselQuery = this.$route.query.find;
    if (!vesselQuery) return false;

    const match = item.vesselName.value.includes(vesselQuery);
    if (match) {
      setTimeout(() => {
        if (!this.$refs[`rowIndex${rowIndex}`]) return;
        (this.$refs[`rowIndex${rowIndex}`] as any).classList.remove("redirected");
      }, 8000);
    } else {
      const redirectedVesselRowIndex = this.rows.findIndex((row: DataQualityRow) => row.vesselName.value.includes(vesselQuery));
      if (redirectedVesselRowIndex === -1) return false;
      const pageIndex = Math.floor(redirectedVesselRowIndex / this.pageLimit);
      this.currentPage = pageIndex + 1; // Update the page to the correct page index
      setTimeout(() => {
        Object.keys(this.$refs).forEach((key: any) => {
          if ((this.$refs[key] as any).classList.contains("redirected")) (this.$refs[key] as any).classList.remove("redirected");
        });
      }, 8000);
    }
    return match;
  }

  onSettingsClick(row: any): void {
    this.$emit("onSettingsClick", row.vesselId);
  }

  showOutliersInManageModal(indicatorData: IndicatorData): void {
    this.$emit("showOutliersInManageModal", indicatorData);
  }

  showTimeline(indicatorData: IndicatorData): void {
    this.$emit("showTimeline", indicatorData);
  }

  showVesselTimelines(vesselData: { vesselId: number; vesselName: string }): void {
    this.$emit("showVesselTimelines", vesselData);
  }

  autoRemoveChanged(payload: { vesselId: number; enabled: boolean }): void {
    this.$emit("autoRemoveChanged", payload);
  }

  sort(value: any): void {
    if (this.sortBy === value) {
      if (this.sortDesc) {
        this.sortBy = "";
        this.sortDesc = false;
      } else {
        this.sortDesc = true;
      }
    } else {
      this.sortBy = value;
      this.sortDesc = false;
    }
  }

  //  @Hooks
  async created() {
    setTimeout(() => ((this as any).isLoadingTextDisplay = true), 3000);
  }
}
